import { Box, Stack } from "@mui/material";
import { Button } from "@src/appV2/redesign/components/Button";
import { TopLeftBackButton } from "@src/appV2/redesign/components/TopLeftBackButton";
import { Illustration, Text } from "@src/appV2/redesign/system/ui-components";

interface IntroStepProps {
  onNext: () => void;
  onBack: () => void;
}

export function IntroStep(props: IntroStepProps) {
  const { onNext, onBack } = props;

  return (
    <Stack
      spacing={6}
      alignItems="center"
      sx={{
        width: "100%",
        height: "100%",
        justifyContent: "space-between",
      }}
    >
      <Box sx={{ width: "100%" }}>
        <TopLeftBackButton iconType="chevron-left" onClick={onBack} />
      </Box>

      <Stack spacing={5} alignItems="center" sx={{ width: "100%" }}>
        <Illustration type="clipboard-bunny" />
        <Text bold variant="h4" sx={{ maxWidth: 320 }}>
          Your reliability earns you early access to the best shifts
        </Text>
        <Text variant="body1" sx={{ color: (t) => t.palette.text.secondary, maxWidth: 320 }}>
          Before you book your first shift, take 3 minutes to learn about Clipboard Score and how it
          changes with your activity.
        </Text>
      </Stack>

      <Button
        fullWidth
        size="large"
        variant="contained"
        sx={{
          borderRadius: 999,
          height: 56,
        }}
        onClick={() => {
          onNext();
        }}
      >
        Let’s get started
      </Button>
    </Stack>
  );
}
